import { Button, Typography } from "@suraasa/placebo-ui"
import { theme, useMediaQuery } from "@suraasa/placebo-ui-legacy"
import clsx from "clsx"

const Header = ({
  showButton,
  onClick,
}: {
  showButton: boolean
  onClick: () => void
}) => {
  const isXsDown = useMediaQuery(theme.breakpoints.down("xs"))
  return (
    <div className="flex flex-col items-center justify-between pb-3 pt-6 sm:flex-row">
      <Typography
        style={{ fontFamily: "Space Grotesk Bold" }}
        className="!text-[40px] !leading-10 !tracking-[-1px]"
      >
        Teacher Impact Awards
      </Typography>
      {/* {!submission && !isVideoSubmitted && ( */}
      {showButton && (
        <Button
          color="black"
          size="md"
          //   onClick={handleUploadClick}
          onClick={onClick}
          className={clsx("mt-1 sm:mt-0", {
            "w-full": isXsDown,
          })}
        >
          Upload My Submission
        </Button>
      )}
    </div>
  )
}

export default Header
